<template>
    <div>

        <div>
            <div style="display: inline-block;width: 20px;overflow: hidden" v-if="isOpt">
                <el-checkbox @change="check" v-model="radio" :label="true"></el-checkbox>
            </div>
            <div class="tag-title">{{titleCon}}</div>

            <span v-for="(item,key) in tagLists" :key="key">
               <span>
                  <el-input
                          v-if="item.isEdit"
                          @blur="e=>blurTag(item)"
                          :ref="item.id"
                          autofocus="autofocus"
                          v-model="item.name"
                          @keyup.enter.native="e=>blurTag(item)"
                          class="my-add-input-wrap"
                          style="width:100px;height: 24px;line-height: 24px" size="small"
                          palceholder="请输入标签名称"></el-input>
               </span>
                   <div v-if="!item.isEdit" @click='e=>clickTagItem(item)'
                        :class="['tag-item',item.isActive?'tag-item-active':'']">{{item.name}}
                <i
                        @click="e=>deleteTag(item)" v-if="isDelete"
                        class="iconfont iconquxiao cancel-icon">

                </i>
              </div>
            </span>

            <div v-if="isDelete" class="cancel-btn" @click="cancelDelete">取消</div>
            <span>
                <el-input @keyup.enter.native="enterClick" v-if="isAdd" class="my-add-input-wrap" v-model="tagName"
                          style="width:100px;height: 24px;line-height: 24px" size="small"
                          palceholder="请输入标签名称"></el-input>
            </span>
            <span>
                <div class="tag-item-add" v-if="!isAdd&&!isDelete&&isOpt" @click="e=>deleteClick(e)"><i
                        class="iconfont iconjianshao"></i></div>
                <div class="tag-item-add" v-if="!isAdd&&!isDelete&&isOpt" @click="handleAdd">
                    <i class="iconfont iconzengjia"></i>
                </div>
            </span>
        </div>
    </div>

</template>

<script>
  import axios from 'axios'
  import moment from 'moment'
  let touchtime = new Date().getTime();
  export default {
    name: 'Role',
    props: {
      isOpt: {
        type: Boolean,
        default: true
      },
      isCheck: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: '款式'
      },
      tagParentId: {
        type: Number,
        default: 0
      },
      tagList: {
        type: Array,
        default: function () {
          return []
        }
      }
    },
    data() {
      return {
        tagName: '',
        isDelete: false,
        isAdd: false,
        tagLists: this.tagList.map(item => Object.assign(item, {isEdit: false, ref: item.id})),
        titleCon: this.title,
        id: this.tagParentId,
        radio: this.isCheck,
        isEdit: false

      }
    },
    components: {},
    mounted() {

    },
    watch: {
      tagList(tags){
        this.tagLists=tags
      },
      isCheck(val){
        console.info(val)
        this.radio = val
      },
      tagList(array){
        this.tagLists = array
      },
      title(val){
        console.info('change...')
        this.titleCon = val
      },
      tagParentId(id){
        this.id = id
      }
    },
    methods: {
      enterClick(e){
        this.isAdd = false
        this.$emit('addItemTagClick', this.id, this.tagName)
        this.tagName = ''


      },
      deleteClick(){
        this.isDelete = true
      },
      handleAdd(){
        this.isAdd = true
      },
      cancelDelete(){
        this.isDelete = false
      },
      //删除标签
      deleteTag(tag){
        this.$confirm(`确认删除${tag.name}标签吗`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$emit('deleteTagClick', tag)
        }).catch(() => {

        })
      },
      check(id){
        this.$emit('check', this.id)
      },
      clickTagItem(each){
        if (this.isOpt == false) {
          this.tagLists = this.tagLists.map(item => item.id == each.id ? Object.assign(item, {isActive: !item.isActive}) : item)
          let emitObj = {id: this.id, tag:each}
          this.$emit('handleTagClick', emitObj)
          return
        } else {
          this.tagLists = this.tagLists.map(e => e.id == each.id ? Object.assign(e, {isEdit: true}) : Object.assign(e, {isEdit: false}))
          this.$nextTick(function () {
            let ref = each.id
            let component = this.$refs[ref][0]
            component.focus()
          })
        }

      },
      blurTag(item){
        this.isEdit = false
        this.$emit('blurTag', item)

      },
    }
  }
</script>
<style lang="stylus" scoped>
    .tag-title {
        font-weight: 700;
        font-size: 14px;
        display: inline-block;
        padding: 5px 6px;
        margin: 2px 4px 2px 0px
    }

    .tag-item {
        display: inline-block;
        padding: 5px 6px;
        position: relative;
        border: 1px solid #409eff;
        margin: 2px 4px;
        font-size: 14px;
        border-radius: 3px;
        cursor: pointer;
    }

    .tag-item-add {
        display: inline-block;
        padding: 1px 6px;
        position: relative;
        font-size: 14px;
        cursor: pointer;
        margin: 0px;
    }

    .cancel-icon {
        background: white;
        position: absolute;
        top: -5px;
        right: -6px;
        font-size: 14px;
        color: #409eff;
        cursor: pointer
    }

    .cancel-btn {
        display: inline-block;
        font-size: 14px;
        margin: 2px 4px;
        padding: 5px 6px;
        background: #409eff;
        color: white;
        border-radius: 5px;
        cursor: pointer
    }

    .tag-item-active {
        background: #409eff;
        color: white;
    }
</style>




// WEBPACK FOOTER //
// src/main/admin/component/TagListComponent.vue